import { useEffect } from 'react';
import { haptic } from '../lib/haptics';

export function NativeInteractionManager() {
  useEffect(() => {
    const mobile = window.matchMedia('(max-width: 760px) and (pointer: coarse)');

    const click = (event: MouseEvent) => {
      if (!mobile.matches) return;
      const target = event.target instanceof Element
        ? event.target.closest('button:not(:disabled), a, [role="button"]')
        : null;
      if (!target || target.closest('[aria-disabled="true"]')) return;
      haptic(target.matches('.button--danger, .button--soft-danger, .mobile-record-delete') ? 'warning' : 'selection');
    };

    let sheet: HTMLElement | null = null;
    let startY = 0;
    let currentY = 0;

    const touchStart = (event: globalThis.TouchEvent) => {
      if (!mobile.matches || event.touches.length !== 1) return;
      const target = event.target instanceof Element ? event.target : null;
      const header = target?.closest('.operational-modal > header, .mini-modal > header');
      if (!header || target?.closest('button, input, select, textarea, a')) return;
      sheet = header.parentElement as HTMLElement | null;
      startY = event.touches[0]!.clientY;
      currentY = startY;
      sheet?.classList.add('is-sheet-dragging');
    };

    const touchMove = (event: globalThis.TouchEvent) => {
      if (!sheet || event.touches.length !== 1) return;
      currentY = event.touches[0]!.clientY;
      const distance = Math.max(0, currentY - startY);
      sheet.style.setProperty('--sheet-drag-y', `${Math.min(distance, 180)}px`);
    };

    const touchEnd = () => {
      if (!sheet) return;
      const active = sheet;
      const distance = currentY - startY;
      active.classList.remove('is-sheet-dragging');
      active.style.removeProperty('--sheet-drag-y');
      sheet = null;
      if (distance < 88) return;
      haptic('light');
      const close = active.querySelector<HTMLElement>(':scope > header .icon-button');
      close?.click();
    };

    document.addEventListener('click', click, true);
    document.addEventListener('touchstart', touchStart, { passive: true });
    document.addEventListener('touchmove', touchMove, { passive: true });
    document.addEventListener('touchend', touchEnd, { passive: true });
    return () => {
      document.removeEventListener('click', click, true);
      document.removeEventListener('touchstart', touchStart);
      document.removeEventListener('touchmove', touchMove);
      document.removeEventListener('touchend', touchEnd);
    };
  }, []);

  return null;
}
